import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import axiosInstances from "../../components/axiosInstance";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";

const Play = ()=>{
    const [plays, setPlays] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [balance,setBalance] = useState(''); 

    useEffect(() => {
        (
        async () => {

            const {data} = await axiosInstances.read.get(`myDrawTickets?page=${page}`);
            setPlays(data.data);
            setLastPage(data.meta.last_page);
            const balanceValue = data.meta.balance;
            setBalance(balanceValue);
            //console.log(data.meta.balance);

        }
        )();
    },[page]);
    

 
    return (
        <Wrapper pageTitle={'Participer au Tirage'}>
            <InnerNav createLink={'/PlayCreate'} listLink={'/plays'} />
            <div className="w-full overflow-hidden rounded-lg shadow-xs">
                <div className="w-full overflow-x-auto">
                    <div className="h-12">Solde du portefeuille: <span className="text-2xl text-rose-600">{balance}</span> </div>

                    <table className="w-full whitespace-no-wrap">
                        <thead>
                            <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                <th className="px-4 py-3">#Ref </th>
                                <th className="px-4 py-3">Date</th>
                                <th className="px-4 py-3">Numéro </th>
                                <th className="px-4 py-3">Montant </th>
                                <th className="px-4 py-3">Ticket </th>
                                <th className="px-4 py-3">Tirage</th>
                                <th className="px-4 py-3">Statut</th> 
                            </tr>
                            </thead>
                            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                {plays.map((play)=>{
                                        return(
                                            <tr key={play.id} className="text-gray-700 dark:text-gray-400">
                                                <td className="px-4 py-5">{play.id}</td>
                                                <td className="px-4 py-3 text-sm">{play.date}</td>
                                                <td className="px-4 py-3 text-sm">{play.msisdn}</td>
                                                <td className="px-4 py-3 text-sm">{play.amount}</td>
                                                <td className="px-4 py-3 text-sm">{play.ticket_no}</td>
                                                <td className="px-4 py-3 text-sm">{play.draw_number}</td>
                                                <td className="px-4 py-3 text-sm">{play.status}</td>
                                                {/* <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/play/${play.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(play.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td> */}
                                            </tr>
                                        );
                                    })
                                }
                        </tbody>
                    </table>
                </div>
                <Paginator lastPage={lastPage} pageChanged={setPage} />
            </div>
        </Wrapper>
    );
};
export default Play;